<template>
  <div class="reload"></div>
</template>

<script>
export default {
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.path = from.path
    })
    
  },
  data(){
    return {
      path:""
    }
  },
  mounted(){
    this.$router.push(this.path)
  }
}
</script>

<style lang="scss" scoped>
.reload {
   background: rgba($mainColor,0.2);
}
</style>